import classnames from 'classnames';
import React, { useCallback } from 'react';
import { IoIosCheckmark as TickIcon } from 'react-icons/io';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';

import { toggleFilter } from '../../redux/actions';

const useStyles = createUseStyles({
  button: {
    '&.showcompleted': { color: '#393939' },
    '&.showcompleted:hover': { color: '#FFAE49' },
    '&:hover': { color: '#393939' },
    background: '#272727',
    borderRadius: 24,
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.45)',
    color: '#FFAE49',
    composes: ['is-block', 'no-overflow'],
    height: 48,
    transition: 'color 0.3s, background 0.3s',
    width: 48,
  },
  icon: {
    verticalAlign: 'middle',
  },
});

const CheckButtonComponent = React.memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const filters = useSelector(_ => _.filters);
  const showcompleted = filters.includes('completed');

  const clickHandler = useCallback(
    (types, visible) => dispatch(toggleFilter(types, visible)),
    [dispatch]
  );

  return (
    <button
      className={classnames(classes.button, { showcompleted })}
      type="button"
      onClick={() => clickHandler(['completed'], !showcompleted)}>
      <TickIcon className={classes.icon} size={42} />
    </button>
  );
});

CheckButtonComponent.displayName = 'CheckButtonComponent';

export default CheckButtonComponent;
